import React, { Component, PropTypes } from 'react';
import './NavItem.css';
import DownArrow from '../../icons/DownArrow';
import { Link } from 'react-router-dom';

class NavItem extends Component {
  render() {
		let styleClass = 'navItem ';
		const { currentRoute, toRoute, showArrow, name } = this.props;
		if (currentRoute === toRoute) styleClass = styleClass + 'navItem__active';
    return (
      <div className="navItem__wrap">
  			<Link to={this.props.toRoute} className={styleClass}>
  				{name}
  			</Link>
      </div>
    );
  }
}

NavItem.propTypes = {
	toRoute: PropTypes.string.isRequired,
	currentRoute: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired
};

export default NavItem;



/** WEBPACK FOOTER **
 ** ./src/components/NavItem/index.js
 **/